import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import IMAGES from 'modules/assets/web';

import ExistingEntryItems from './ExistingEntryItems';
import ActiveNavItem from './ActiveNavItem';

class NavItems extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: () => {},
  };

  render() {
    return (
      <React.Fragment>
        <ExistingEntryItems onClick={this.props.onClick} />
        <ActiveNavItem path="onboarding">
          <Link
            className="nav-link text-white"
            to="/onboarding"
            onClick={this.props.onClick}
          >
            <img alt="icon-onboarding" src={IMAGES.SIDEBAR_ONBOARDING} />
            Onboarding
          </Link>
        </ActiveNavItem>
      </React.Fragment>
    );
  }
}

export default NavItems;
